import { VBToggle } from './toggle';
import { pluginFactory } from '../../utils/plugins';
var VBTogglePlugin =
/*#__PURE__*/
pluginFactory({
  directives: {
    VBToggle: VBToggle
  }
});
export { VBTogglePlugin, VBToggle };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/directives/toggle/index.js
// module id = ./node_modules/bootstrap-vue/esm/directives/toggle/index.js
// module chunks = 1